import { Box, Checkbox, FormControlLabel } from '@mui/material';

import {
    ADMIN_PRIVILEGE_GROUPS,
    getGroupState,
    normalizeAdminPrivileges,
    togglePrivilegeGroup
} from './adminPrivilegesConfig';

const AdminPrivilegeSelector = ({ privileges, onChange }) => {
    const normalized = normalizeAdminPrivileges(privileges);

    const handlePrivilegeChange = ({ target: { name, checked } }) => {
        onChange({ ...normalized, [name]: checked });
    };

    const handleGroupChange = (group, checked) => {
        onChange(togglePrivilegeGroup(normalized, group, checked));
    };

    return (
        <Box>
            {ADMIN_PRIVILEGE_GROUPS.map(group => {
                const state = getGroupState(normalized, group);
                return (
                    <Box key={group.key}>
                        <FormControlLabel
                            label={group.label}
                            control={
                                <Checkbox
                                    name={group.key}
                                    checked={state.checked}
                                    indeterminate={state.indeterminate}
                                    onChange={({ target }) => handleGroupChange(group, target.checked)}
                                />
                            }
                        />
                        <Box sx={{ display: 'flex', flexDirection: 'column', ml: 3 }}>
                            {group.privileges.map((privilege, index) => (
                                <FormControlLabel
                                    key={`${group.key}-${privilege.key}-${index}`}
                                    label={privilege.label}
                                    control={
                                        <Checkbox
                                            name={privilege.key}
                                            checked={normalized[privilege.key]}
                                            onChange={handlePrivilegeChange}
                                        />
                                    }
                                />
                            ))}
                        </Box>
                    </Box>
                );
            })}
            <FormControlLabel
                label="Lista administradores"
                control={
                    <Checkbox
                        name="admins"
                        checked={normalized.admins}
                        onChange={handlePrivilegeChange}
                    />
                }
            />
        </Box>
    );
};

export default AdminPrivilegeSelector;
